import type { TransactionCountByPlatform } from "@stepfinance/transaction-history";
import { useQuery } from "@tanstack/react-query";
import { random } from "lodash";
import shallow from "zustand/shallow";

import { useEnrichedWallet } from "../../../contexts/enrichedWallet";
import { STEP_API_ENDPOINT } from "../../../utils/swr";
import { fetchJSONFromUrl } from "../../../utils/utils";
import { useStepAuthStore } from "../../stores/stepAuth";
import { useTransactionHistoryStore } from "../../stores/transactionHistoryStore";
import { queryConfig } from "../queryConfig";
import { useTransactionCacheStatus } from "./useTransactionCacheStatus";

export const useTransactionPlatformStats = () => {
  const { publicKey } = useEnrichedWallet();
  const selectedYear = useTransactionHistoryStore((s) => s.selectedYear, shallow);
  const { data: transactionCacheStatus } = useTransactionCacheStatus();
  const jwt = useStepAuthStore((s) => s.jwt);

  const fetchTransactionCountByPlatform = async () => {
    if (publicKey) {
      // TODO: Remove cache breaker once we have a better way to invalidate cache
      // should be able to make one off request with cache breaker after initial scan is complete
      // currently on every request
      const cacheBreaker = `&c=${random(1000)}`;
      const data: TransactionCountByPlatform = await fetchJSONFromUrl(
        `${STEP_API_ENDPOINT}/v1/transaction-history/transactions-per-platform?pubkey=${publicKey.toBase58()}&year=${selectedYear}${cacheBreaker}`,
        { headers: { Authorization: `bearer ${jwt}` } },
      );

      return data;
    }
  };

  return useQuery<TransactionCountByPlatform | undefined>(
    ["tx-history", "transactions-per-platform", publicKey?.toBase58(), selectedYear, jwt],
    fetchTransactionCountByPlatform,
    {
      ...queryConfig,
      enabled: publicKey !== null && transactionCacheStatus?.initialScanComplete,
    },
  );
};
